import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const B = '#0B3D6E', T = '#0F6E56', TACCENT = '#1D9E75';

function StatCard({ n, label, delay = 0 }) {
  return (
    <div style={{ textAlign: 'center', padding: '1rem 0.5rem', animation: `fadeInUp 0.5s ${delay}ms ease both` }}>
      <div style={{ fontSize: 'clamp(22px,5vw,30px)', fontWeight: 700, color: B, fontFamily: "'Syne', sans-serif", letterSpacing: '-0.5px' }}>{n}</div>
      <div style={{ fontSize: 11, color: '#64748b', marginTop: 3, textTransform: 'uppercase', letterSpacing: '0.5px' }}>{label}</div>
    </div>
  );
}

function SpecCard({ title, desc, count, color, stroke, icon, delay }) {
  const [hov, setHov] = useState(false);
  return (
    <Link to="/catalogue" style={{ textDecoration: 'none', color: 'inherit', display: 'block', animation: `fadeInUp 0.5s ${delay}ms ease both` }}>
      <div style={{
        background: '#fff', border: `1px solid ${hov ? stroke : '#e2e8f0'}`,
        borderRadius: 14, padding: '1.25rem', cursor: 'pointer',
        transition: 'border-color 0.18s, transform 0.18s, box-shadow 0.18s',
        transform: hov ? 'translateY(-2px)' : 'none',
        boxShadow: hov ? `0 8px 24px rgba(0,0,0,0.1)` : '0 1px 3px rgba(0,0,0,0.05)',
      }} onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}>
        <div style={{ width: 44, height: 44, borderRadius: 12, background: color, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 12 }}>
          <svg viewBox="0 0 24 24" style={{ width: 22, height: 22, fill: 'none', stroke: stroke, strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round' }}>{icon}</svg>
        </div>
        <div style={{ fontSize: 13.5, fontWeight: 600, marginBottom: 5, color: '#0f172a' }}>{title}</div>
        <div style={{ fontSize: 11.5, color: '#64748b', lineHeight: 1.6, marginBottom: 10 }}>{desc}</div>
        <div style={{ fontSize: 11, fontWeight: 600, color: stroke, display: 'flex', alignItems: 'center', gap: 4 }}>
          {count} produits
          <svg viewBox="0 0 24 24" style={{ width: 11, height: 11, fill: 'none', stroke: stroke, strokeWidth: 2 }}><path d="M9 18l6-6-6-6"/></svg>
        </div>
      </div>
    </Link>
  );
}

function OfferCard({ icon, title, desc, cta, to, accent, delay }) {
  const [hov, setHov] = useState(false);
  return (
    <div style={{
      background: '#fff', border: `1.5px solid ${hov ? accent : '#e8edf3'}`,
      borderRadius: 16, padding: '1.5rem', display: 'flex', flexDirection: 'column',
      transition: 'border-color 0.18s, box-shadow 0.18s',
      boxShadow: hov ? `0 8px 28px rgba(0,0,0,0.1)` : '0 2px 6px rgba(0,0,0,0.04)',
      animation: `fadeInUp 0.5s ${delay}ms ease both`,
    }} onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}>
      <div style={{ width: 48, height: 48, borderRadius: 14, background: accent + '18', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1rem' }}>
        <svg viewBox="0 0 24 24" style={{ width: 24, height: 24, fill: 'none', stroke: accent, strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round' }}>{icon}</svg>
      </div>
      <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 8, fontFamily: "'Syne', sans-serif", color: '#0f172a' }}>{title}</div>
      <div style={{ fontSize: 13, color: '#64748b', lineHeight: 1.7, flex: 1, marginBottom: '1.25rem' }}>{desc}</div>
      <Link to={to} style={{
        display: 'inline-flex', alignItems: 'center', gap: 6,
        background: accent, color: '#fff', padding: '9px 16px',
        borderRadius: 9, fontSize: 12, fontWeight: 600, textDecoration: 'none',
        transition: 'opacity 0.15s', width: 'fit-content',
      }}
        onMouseEnter={e => e.currentTarget.style.opacity = '0.88'}
        onMouseLeave={e => e.currentTarget.style.opacity = '1'}
      >
        {cta}
        <svg viewBox="0 0 24 24" style={{ width: 13, height: 13, fill: 'none', stroke: '#fff', strokeWidth: 2 }}><path d="M9 18l6-6-6-6"/></svg>
      </Link>
    </div>
  );
}

export default function Home({ lang }) {
  const fr = lang === 'fr';
  const [whatsappHov, setWhatsappHov] = useState(false);

  const stats = [
    { n: '500+', l: fr ? 'Références' : 'References' },
    { n: '120+', l: fr ? 'Établissements' : 'Institutions' },
    { n: '48h',  l: fr ? 'Livraison' : 'Delivery' },
    { n: '99%',  l: fr ? 'Satisfaction' : 'Satisfaction' },
  ];

  const specs = [
    { title: fr?'Cardiologie':'Cardiology', desc: fr?'Moniteurs, ECG, défibrillateurs':'Monitors, ECG, defibrillators', count:'34', color:'#E6F1FB', stroke:B, icon:<path d="M22 12h-4l-3 9L9 3l-3 9H2"/> },
    { title: fr?'Chirurgie':'Surgery', desc: fr?'Instruments & consommables stériles':'Instruments & sterile consumables', count:'87', color:'#E1F5EE', stroke:T, icon:<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/> },
    { title: fr?'Radiologie':'Radiology', desc: fr?'Imagerie, protection, consommables':'Imaging, protection, consumables', count:'52', color:'#FAEEDA', stroke:'#BA7517', icon:<path d="M9 3H5a2 2 0 00-2 2v4m6-6h10a2 2 0 012 2v4M9 3v11m0 0H5a2 2 0 00-2 2v4a2 2 0 002 2h4m0-6h6m0 0v6a2 2 0 002 2h4a2 2 0 002-2v-4m-6-6h6"/> },
    { title: fr?'Laboratoire':'Laboratory', desc: fr?'Réactifs, tubes, analyseurs':'Reagents, tubes, analyzers', count:'96', color:'#E6F1FB', stroke:B, icon:<path d="M9 3h6M9 3v7l-4 9a1 1 0 001 1h12a1 1 0 001-1l-4-9V3"/> },
    { title: fr?'Réanimation':'Intensive care', desc: fr?'Respirateurs, moniteurs, pompes':'Ventilators, monitors, pumps', count:'41', color:'#E1F5EE', stroke:T, icon:<><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/></> },
    { title: fr?'Urgences':'Emergency', desc: fr?'Chariot urgence, sutures, pansements':'Cart, sutures, dressings', count:'63', color:'#FAEEDA', stroke:'#BA7517', icon:<path d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"/> },
  ];

  const offers = [
    {
      icon: <><path d="M20 7H4a2 2 0 00-2 2v6a2 2 0 002 2h16a2 2 0 002-2V9a2 2 0 00-2-2z"/><path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16"/></>,
      title: fr ? 'Distribution médicale' : 'Medical distribution',
      desc: fr ? '500+ références certifiées CE. Médicaments, dispositifs médicaux, consommables. Livraison 24–48h sur tout le Maroc.' : '500+ CE-certified references. Medicines, devices, consumables. 24–48h delivery across Morocco.',
      cta: fr ? 'Voir le catalogue' : 'View catalogue',
      to: '/catalogue', accent: B, delay: 0,
    },
    {
      icon: <><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></>,
      title: fr ? 'Centrale d\'achat' : 'Purchasing group',
      desc: fr ? 'Regroupez vos achats avec d\'autres cliniques. Réduction 15–30% sur les volumes. Tarifs négociés annuellement.' : 'Pool your purchases with other clinics. 15–30% volume discounts. Annually negotiated rates.',
      cta: fr ? 'En savoir plus' : 'Learn more',
      to: '/contact', accent: T, delay: 80,
    },
    {
      icon: <><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></>,
      title: 'StockMed SaaS',
      desc: fr ? 'Logiciel de gestion de stock et pharmacie clinique. Alertes péremption, traçabilité, rapports automatiques.' : 'Stock & clinical pharmacy management software. Expiry alerts, traceability, automatic reports.',
      cta: fr ? 'Essayer gratuitement' : 'Try for free',
      to: '/stock', accent: '#7F77DD', delay: 160,
    },
  ];

  const partners = ['CHU Ibn Rochd — Casablanca', 'Hôpital Cheikh Khalifa', 'Clinique Al Wafaa', 'CHU Hassan II — Fès', 'Clinique du Palmier', 'Centre Oncologie Ibn Rochd', '+ 114 établissements'];

  const testimonials = [
    { name: 'Dr. Rachid B.', role: fr?'Directeur médical — Clinique Al Wafaa':'Medical Director — Clinique Al Wafaa', quote: fr?'LOMED Medicare nous a permis de réduire nos coûts d\'achat de 22% tout en améliorant la traçabilité.':'LOMED Medicare helped us reduce procurement costs by 22% while improving traceability.' },
    { name: 'Mme. Fatima E.', role: fr?'Responsable achat — Polyclinique Atlas':'Purchasing Manager — Polyclinique Atlas', quote: fr?'Réactivité exemplaire, livraison toujours dans les délais. StockMed a transformé notre gestion de stock.':'Exemplary responsiveness, always on-time delivery. StockMed transformed our stock management.' },
  ];

  return (
    <div style={{ maxWidth: 980, margin: '0 auto', padding: '1.5rem 1rem' }}>

      {/* ── HERO ── */}
      <div style={{
        background: `linear-gradient(135deg, ${B} 0%, #1a5c94 50%, ${T} 100%)`,
        borderRadius: 20, padding: 'clamp(1.5rem,5vw,3rem)', color: '#fff',
        marginBottom: '2rem', position: 'relative', overflow: 'hidden',
        animation: 'fadeInUp 0.6s ease both',
      }}>
        {/* Decorative circles */}
        <div style={{ position: 'absolute', width: 320, height: 320, borderRadius: '50%', border: '1px solid rgba(255,255,255,0.07)', right: -80, top: -100, pointerEvents: 'none' }}/>
        <div style={{ position: 'absolute', width: 180, height: 180, borderRadius: '50%', border: '1px solid rgba(255,255,255,0.05)', right: 60, bottom: -60, pointerEvents: 'none' }}/>
        <div style={{ position: 'absolute', width: 80, height: 80, borderRadius: '50%', background: 'rgba(255,255,255,0.04)', right: '15%', top: '20%', pointerEvents: 'none' }}/>

        {/* Badge */}
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: 7, background: 'rgba(255,255,255,0.13)', backdropFilter: 'blur(8px)', padding: '5px 14px', borderRadius: 20, fontSize: 11, letterSpacing: '0.4px', marginBottom: 16, border: '1px solid rgba(255,255,255,0.18)' }}>
          <span style={{ width: 7, height: 7, background: TACCENT, borderRadius: '50%', display: 'inline-block', animation: 'pulse-dot 2s infinite' }}/>
          {fr ? 'Distributeur agréé — Ministère de la Santé Maroc' : 'Licensed Distributor — Moroccan Ministry of Health'}
        </div>

        <h1 style={{ fontSize: 'clamp(20px,4.5vw,34px)', fontWeight: 700, lineHeight: 1.2, marginBottom: 14, maxWidth: 520, fontFamily: "'Syne', sans-serif" }}>
          {fr ? <>Réduisez vos coûts d'achat médical<br/><span style={{ color: TACCENT }}>de 15 à 30%</span></> : <>Reduce your medical<br/>procurement costs by <span style={{ color: TACCENT }}>15–30%</span></>}
        </h1>

        <p style={{ fontSize: 14, opacity: 0.88, lineHeight: 1.75, maxWidth: 440, marginBottom: '1.75rem' }}>
          {fr ? 'Dispositifs médicaux certifiés CE, centrale d\'achat groupée et logiciel StockMed — livrés sous 48h aux établissements de santé du Maroc.' : 'CE-certified medical devices, group purchasing, and StockMed software — delivered within 48h to Moroccan healthcare facilities.'}
        </p>

        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
          <Link to="/devis" style={{
            background: '#fff', color: B, padding: '12px 24px', borderRadius: 10,
            fontSize: 13, fontWeight: 700, textDecoration: 'none',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          }}>
            {fr ? '📋 Demander un devis gratuit' : '📋 Request a free quote'}
          </Link>
          <Link to="/catalogue" style={{
            background: 'rgba(255,255,255,0.12)', color: '#fff',
            border: '1px solid rgba(255,255,255,0.28)', padding: '12px 24px',
            borderRadius: 10, fontSize: 13, fontWeight: 500, textDecoration: 'none',
          }}>
            {fr ? 'Voir le catalogue' : 'View catalogue'}
          </Link>
        </div>

        {/* Trust badges in hero */}
        <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginTop: '1.5rem', paddingTop: '1.5rem', borderTop: '1px solid rgba(255,255,255,0.12)' }}>
          {[
            { icon: '✓', label: fr?'Certifié CE':'CE Certified' },
            { icon: '✓', label: fr?'ISO 13485':'ISO 13485' },
            { icon: '✓', label: fr?'Livraison 48h':'48h Delivery' },
            { icon: '✓', label: fr?'Sans engagement':'No commitment' },
          ].map(b => (
            <span key={b.label} style={{ fontSize: 11, opacity: 0.85, display: 'flex', alignItems: 'center', gap: 5 }}>
              <span style={{ color: TACCENT, fontWeight: 700 }}>{b.icon}</span> {b.label}
            </span>
          ))}
        </div>
      </div>

      {/* ── STATS ── */}
      <div style={{ background: '#fff', border: '0.5px solid #e2e8f0', borderRadius: 16, padding: '0.5rem 1rem', marginBottom: '2rem', display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(100px,1fr))', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
        {stats.map((s, i) => <StatCard key={s.l} n={s.n} label={s.l} delay={i * 60} />)}
      </div>

      {/* ── 3 OFFRES ── */}
      <div style={{ marginBottom: '2.5rem' }}>
        <div style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '1px', color: T, marginBottom: 5 }}>{fr ? 'Nos offres' : 'Our offers'}</div>
        <h2 style={{ fontSize: 'clamp(16px,3vw,22px)', fontWeight: 700, marginBottom: 6, fontFamily: "'Syne', sans-serif" }}>{fr ? '3 solutions pour les établissements de santé' : '3 solutions for healthcare institutions'}</h2>
        <p style={{ fontSize: 13, color: '#64748b', marginBottom: '1.25rem' }}>{fr ? 'Distribution, centrale d\'achat groupée et gestion de stock SaaS' : 'Distribution, group purchasing and SaaS stock management'}</p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(240px,1fr))', gap: 14 }}>
          {offers.map(o => <OfferCard key={o.title} {...o} />)}
        </div>
      </div>

      {/* ── SPECIALITES ── */}
      <div style={{ marginBottom: '2.5rem' }}>
        <div style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '1px', color: T, marginBottom: 5 }}>{fr ? 'Nos domaines' : 'Our domains'}</div>
        <h2 style={{ fontSize: 'clamp(16px,3vw,22px)', fontWeight: 700, marginBottom: 6, fontFamily: "'Syne', sans-serif" }}>{fr ? 'Spécialités médicales couvertes' : 'Medical specialties covered'}</h2>
        <p style={{ fontSize: 13, color: '#64748b', marginBottom: '1.25rem' }}>{fr ? 'Dispositifs certifiés pour chaque service hospitalier' : 'Certified devices for every hospital department'}</p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(155px,1fr))', gap: 12 }}>
          {specs.map((sp, i) => <SpecCard key={sp.title} {...sp} delay={i * 50} />)}
        </div>
      </div>

      {/* ── TEMOIGNAGES ── */}
      <div style={{ marginBottom: '2.5rem' }}>
        <div style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '1px', color: T, marginBottom: 5 }}>{fr ? 'Témoignages' : 'Testimonials'}</div>
        <h2 style={{ fontSize: 'clamp(16px,3vw,22px)', fontWeight: 700, marginBottom: '1.25rem', fontFamily: "'Syne', sans-serif" }}>{fr ? 'Ils nous font confiance' : 'They trust us'}</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(280px,1fr))', gap: 14 }}>
          {testimonials.map((t, i) => (
            <div key={i} style={{ background: '#fff', border: '0.5px solid #e2e8f0', borderRadius: 14, padding: '1.5rem', boxShadow: '0 2px 8px rgba(0,0,0,0.05)', animation: `fadeInUp 0.5s ${i*100}ms ease both` }}>
              <div style={{ fontSize: 28, color: B, opacity: 0.15, fontFamily: 'Georgia, serif', lineHeight: 1, marginBottom: 8 }}>"</div>
              <p style={{ fontSize: 13.5, color: '#475569', lineHeight: 1.75, marginBottom: '1rem', fontStyle: 'italic' }}>{t.quote}</p>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <div style={{ width: 38, height: 38, borderRadius: '50%', background: '#EBF3FB', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 700, color: B, flexShrink: 0 }}>
                  {t.name.charAt(0)}{t.name.split(' ')[1]?.charAt(0)}
                </div>
                <div>
                  <div style={{ fontSize: 13, fontWeight: 600, color: '#0f172a' }}>{t.name}</div>
                  <div style={{ fontSize: 11, color: '#94a3b8' }}>{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ── PARTENAIRES ── */}
      <div style={{ marginBottom: '2.5rem' }}>
        <div style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '1px', color: T, textAlign: 'center', marginBottom: 14 }}>{fr ? '120+ établissements nous font confiance' : '120+ institutions trust us'}</div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, justifyContent: 'center' }}>
          {partners.map(p => (
            <span key={p} style={{ background: '#fff', border: '0.5px solid #dde4ee', borderRadius: 9, padding: '7px 14px', fontSize: 12, color: '#475569', fontWeight: p.startsWith('+') ? 600 : 400, color: p.startsWith('+') ? B : '#475569' }}>{p}</span>
          ))}
        </div>
      </div>

      {/* ── CTA FINAL ── */}
      <div style={{
        background: `linear-gradient(135deg, ${B} 0%, ${T} 100%)`,
        borderRadius: 20, padding: 'clamp(1.5rem,4vw,2.5rem)', textAlign: 'center', color: '#fff',
        marginBottom: '0.5rem', position: 'relative', overflow: 'hidden',
      }}>
        <div style={{ position: 'absolute', width: 200, height: 200, borderRadius: '50%', border: '1px solid rgba(255,255,255,0.06)', left: -60, bottom: -60, pointerEvents: 'none' }}/>
        <h2 style={{ fontSize: 'clamp(16px,3vw,22px)', fontWeight: 700, marginBottom: 10, fontFamily: "'Syne', sans-serif" }}>
          {fr ? 'Réduisez vos coûts dès aujourd\'hui' : 'Reduce your costs today'}
        </h2>
        <p style={{ fontSize: 13, opacity: 0.85, marginBottom: '1.5rem', lineHeight: 1.7, maxWidth: 480, margin: '0 auto 1.5rem' }}>
          {fr ? 'Demandez un devis gratuit et personnalisé. Notre équipe commerciale vous répond sous 24h.' : 'Request a free personalized quote. Our sales team responds within 24h.'}
        </p>
        <div style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to="/devis" style={{ background: '#fff', color: B, padding: '12px 26px', borderRadius: 10, fontSize: 13, fontWeight: 700, textDecoration: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }}>
            {fr ? '📋 Demander un devis gratuit' : '📋 Request a free quote'}
          </Link>
          <a href="https://wa.me/212600000000" target="_blank" rel="noreferrer" style={{ background: '#25D366', color: '#fff', padding: '12px 22px', borderRadius: 10, fontSize: 13, fontWeight: 600, textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 7 }}>
            <svg viewBox="0 0 24 24" style={{ width: 15, height: 15, fill: '#fff' }}><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
            WhatsApp
          </a>
        </div>
      </div>

      {/* WhatsApp floating */}
      <a href="https://wa.me/212600000000" target="_blank" rel="noreferrer"
        style={{
          position: 'fixed', bottom: 24, right: 24, zIndex: 300,
          width: 52, height: 52, borderRadius: '50%',
          background: '#25D366', color: '#fff',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          boxShadow: `0 4px 16px rgba(37,211,102,${whatsappHov ? 0.5 : 0.35})`,
          textDecoration: 'none',
          transform: whatsappHov ? 'scale(1.08)' : 'scale(1)',
          transition: 'transform 0.2s, box-shadow 0.2s',
        }}
        onMouseEnter={() => setWhatsappHov(true)}
        onMouseLeave={() => setWhatsappHov(false)}
        title="WhatsApp"
      >
        <svg viewBox="0 0 24 24" style={{ width: 26, height: 26, fill: '#fff' }}><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
      </a>

    </div>
  );
}

